import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { InstituteEditPage } from '@/features/institutes/pages/InstituteEditPage';
import { instituteListSearchSchema } from '../index';

export const Route = createFileRoute('/_auth/settings/institutes/$instituteId/edit')({
  validateSearch: instituteListSearchSchema,
  component: function EditInstituteRoute() {
    const { instituteId } = Route.useParams();
    return (
      <ErrorBoundary moduleName="Edit Institute">
        <Suspense fallback={<PageLoader />}>
          <InstituteEditPage instituteId={Number(instituteId)} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
